import TagDetailDialog from "./tagDetailDialog.container";

export default TagDetailDialog;
